import React from 'react';
import { IonIcon } from '@ionic/react';
import { cardOutline, locationOutline } from 'ionicons/icons';
import { normalizarProdutoCupom } from '../../../../../Utils/CupomProduto';
import { obterItensFormaPagamento } from '../ProjetosCupom/ProjetosCupom';

export function valorPedidoFormatado(value: any): string {
  if ((typeof value !== 'number' && typeof value !== 'string') || String(value).trim() === '') return 'Valor não informado';
  const text = String(value).trim();
  const number = Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text);
  return Number.isFinite(number) ? number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'Valor não informado';
}

export const PedidoContexto: React.FC<{ pedido: any }> = ({ pedido }) => {
  const retirada = String(pedido.endereco || '').startsWith('RETIRADA');
  const endereco = pedido.endereco === 'RETIRADA' ? pedido.empresaEndereco : pedido.endereco;
  return <>
    {!pedido.clienteInterno && pedido.endereco && <section className="pedido-resumo-section pedido-contexto-item">
      <IonIcon icon={locationOutline} aria-hidden="true" /><div><h2>{retirada ? 'Retirada no estabelecimento' : 'Entrega no seu endereço'}</h2><p>{[endereco, pedido.complemento].filter(Boolean).join(', ')}</p></div>
    </section>}
    {pedido.formaPagamento && <section className="pedido-resumo-section pedido-contexto-item">
      <IonIcon icon={cardOutline} aria-hidden="true" /><div><h2>Pagamento</h2>{obterItensFormaPagamento(pedido.formaPagamento, pedido.valorPagoDinheiro).map((item: any, i: number) => <div className="pedido-valor-linha" key={i}><span>{item.label}</span><span>{item.value}</span></div>)}</div>
    </section>}
  </>;
};

const PedidoResumo: React.FC<{ pedido: any; mostrarContexto?: boolean }> = ({ pedido, mostrarContexto = true }) => (
  <>
    {Array.isArray(pedido.produtos) && pedido.produtos.length > 0 && <section className="pedido-resumo-section">
      <h2>Itens do pedido</h2>
      {pedido.produtos.map((produto: any, index: number) => {
        const item = normalizarProdutoCupom(produto, pedido.pedidoIfood === true || pedido.pedido99Food === true);
        return <div className="pedido-produto" key={produto.pk || produto.sk || index}>
          <span className="pedido-quantidade">{produto.quantidade}</span>
          <div><strong>{item.descricaoPrincipal}</strong>{item.detalhes.map((detalhe, i) => <p key={i}>{detalhe.observacao ? 'Observação: ' : ''}{detalhe.descricao}{!detalhe.observacao && detalhe.valor != null && ` · ${valorPedidoFormatado(detalhe.valor)}`}</p>)}</div>
          {produto.subtotal != null && <strong>{valorPedidoFormatado(produto.subtotal)}</strong>}
        </div>;
      })}
    </section>}
    {Array.isArray(pedido.servicos) && pedido.servicos.length > 0 && <section className="pedido-resumo-section"><h2>Serviços</h2>{pedido.servicos.map((servico: any, i: number) => <div className="pedido-valor-linha" key={i}><span>{servico.quantidade} × {servico.descricao} ({valorPedidoFormatado(servico.valor)})</span><strong>{valorPedidoFormatado(servico.subtotal)}</strong></div>)}</section>}
    <section className="pedido-resumo-section"><h2>Resumo de valores</h2>
      {pedido.taxaEntrega != null && !pedido.clienteInterno && <div className="pedido-valor-linha"><span>Taxa de entrega</span><span>{valorPedidoFormatado(pedido.taxaEntrega)}</span></div>}
      {pedido.desconto != null && <div className="pedido-valor-linha"><span>Desconto</span><span>{valorPedidoFormatado(pedido.desconto)}</span></div>}
      {pedido.taxaServico && pedido.ehComanda ? <div className="pedido-valor-linha"><span>Taxa</span><span>{pedido.taxaServico}%</span></div> : null}
      {pedido.valorTotal != null && <div className="pedido-valor-linha pedido-total"><strong>Total</strong><strong>{valorPedidoFormatado(pedido.valorTotal)}</strong></div>}
    </section>
    {mostrarContexto && <PedidoContexto pedido={pedido} />}
    {pedido.extraInfo && <section className="pedido-resumo-section"><h2>Informações extras</h2><p>{pedido.extraInfo}</p></section>}
  </>
);
export default PedidoResumo;
